import React, { useState } from "react";
import { LanguageLoader } from '../../assets/languages';
import {Toastify} from "../utils";
import md5 from "md5";
import { useSelector } from "react-redux";
const ConfirmCode = ({callback, encryptedOTP, prevStep}) =>
{
    const preferences = useSelector((state) => state.preferences);	
	const language = LanguageLoader(preferences.language);
    const [code, SetCode] = useState('');

    const CheckConfirmCode = () =>
    {
        if (md5(code) === encryptedOTP)
        {
            callback();
        }
        else
        {
            Toastify(language.ERROR.WRONG_CONFIRM_CODE)
        }
    }
    
    return (
        <div>
            <h6 className="mb-4">{language.AUTHENTICATION.INSERT_CONFIRM_CODE}</h6>
            <input placeholder={language.AUTHENTICATION.CONFIRM_CODE} required onChange={(e) => SetCode(e.target.value)}/>
            <div className="mt-14 text-center">
                <button className="w-full" onClick={CheckConfirmCode}>{language.AUTHENTICATION.CONFIRM}</button>
                <button className="w-full secondary" onClick={prevStep}>{language.AUTHENTICATION.RETURN}</button>
            </div>
        </div>
    );
};

export default ConfirmCode;